function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.137 6.873c0 .26.229.472.51.472h4.706c.281 0 .51-.212.51-.472s-.229-.471-.51-.471H5.647c-.282 0-.51.21-.51.471zm0-2.902c0 .26.229.472.51.472h4.706c.281 0 .51-.211.51-.471s-.229-.472-.51-.472H5.647c-.282 0-.51.211-.51.471z",
  fill: "#2D2D2D"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.02 13.078c0 .54.474.979 1.058.979H8.46V15H4.08C2.93 15 2 14.14 2 13.078V2.922C2 1.861 2.93 1 4.078 1h7.844C13.069 1 14 1.86 14 2.922v6.954h-1.02V2.922c0-.54-.474-.979-1.058-.979H4.078c-.584 0-1.058.438-1.058.98v10.155z",
  fill: "#2D2D2D"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.452 10.069a1.384 1.384 0 100 2.767 1.384 1.384 0 000-2.768zM8 11.451a2.452 2.452 0 114.522 1.315l1.322 1.321a.534.534 0 11-.756.756l-1.321-1.322A2.452 2.452 0 018 11.452z",
  fill: "#2D2D2D"
});
function SvgDetalle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}
export default __webpack_public_path__ + "/img/Detalle.svg";
export { SvgDetalle as ReactComponent };